<template>
  <section>
    <div class="container">

      <select style="margin-bottom: 30px;" class="form-control auto-width" v-model="sort.selected" v-on:change="changeSort">
        <option v-for="option in sort.items" v-bind:value="option.value">
          {{ option.label }}
        </option>
      </select>
      <input v-on:keyup="changeSerach" placeholder="Keresés..." class="form-control auto-width" id="kereso" v-model="query.kerkif"></inputbox>

      <div class="competition-items">
        <div v-for="(form, i) in forms" class="competition-item-outer">
          <div class="competition-item">
            <div>
              <i class="fa fa-file-o"></i>
                {{ form.name }}
              <span class="date">{{ form.subname }}</span>
              <router-link class="button" :to="{ path: '/palyazatra_jelentkezes/?id=' + form.id }">Jelentkezem</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="breadcrumbs clearfix">
        <!--<ul>
          <li class="prev"><a href=""><img src="assets/img/arrow.png" alt=""/></a></li>
          <li><a href="">1</a></li>
          <li><a href="">2</a></li>
          <li class="active"><a href="">3</a></li>
          <li><a href="">4</a></li>
          <li><a href="">5</a></li>
          <li><a href="">6</a></li>
          <li><a href="">7</a></li>
          <li class="next"><a href=""><img src="assets/img/arrow.png" alt=""/></a></li>
        </ul>-->
        <div class="result">
          <!--Összesen <span>20</span> találat <span>3</span> oldalon.-->
          Összesen <span>{{ pcs }}</span> találat.
        </div>
      </div>

    </div>
  </section>
</template>
<script>
import Vue from 'vue';

export default {
  data: function() {
    return {
      forms: [],
      pcs: 0,
      query: {
        sort: 'created|asc',
        kerkif: '',
        onlyPublic: 1,
        onlyDateValid: 1
      },
      sort: {
        items: [
          {
            value: 'created|asc',
            label: 'Létrehozás szerint növekvő'
          },
          {
            value: 'created|desc',
            label: 'Létrehozás szerint csökkenőő'
          },
          {
            value: 'name|asc',
            label: 'Név szerint növekvő'
          },
          {
            value: 'name|desc',
            label: 'Név szerint csökkenő'
          }
        ],
        selected: 'created|asc'
      },
    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    var sort_szervezezek = this.query.sort;
    var kerkif_szervezezek = '';
    if(sessionStorage.getItem('sort_szervezezek'))
      sort_szervezezek = sessionStorage.getItem('sort_szervezezek');
    if(sessionStorage.getItem('kerkif_szervezezek'))
      kerkif_szervezezek = sessionStorage.getItem('kerkif_szervezezek');
    this.$router.push({path: '/palyazatok/szerv_jel/?orderby=' +  sort_szervezezek + '&search=' + kerkif_szervezezek});

    if(this.$route.query.orderby) {
      this.sort.selected = this.query.sort = this.$route.query.orderby;
    } else {
      this.sort.selected = this.query.sort;
    }
    if(this.$route.query.search) {
      this.query.kerkif = this.$route.query.search;
    }

    this.getForms();
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      if(this.$route.query.orderby) {
        this.sort.selected = this.$route.query.orderby;
      } else {
        this.sort.selected = this.query.sort;
      }
      if(this.$route.query.search) {
        this.query.kerkif = this.$route.query.search;
      }
      this.query.sort = this.sort.selected;
      if(oldRoute.query.orderby != undefined)
        this.getForms();
    }
  },
  methods: {
    getForms: function() {
      var _this = this;
      this.query.type = this.$route.params.page;
      this.$root.ajax('forms/', {
        method: 'POST',
        data: _this.query,
        success: function(response) {
          if (response.error == false) {
            _this.forms = response.forms;
            _this.pcs = response.pcs;
          } else
            alert(response.error);
        }
      });
    },
    changeSort: function() {
      this.query.sort = this.sort.selected;
      sessionStorage.setItem('sort_szervezezek', this.query.sort);
      this.$router.push({path: '/palyazatok/szerv_jel/?orderby=' +  this.query.sort + '&search=' + this.query.kerkif});
    },
    changeSerach: function() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        sessionStorage.setItem('kerkif_szervezezek', this.query.kerkif);
        this.$router.push({path: '/palyazatok/szerv_jel/?orderby=' +  this.query.sort  + '&search=' + this.query.kerkif});
      }, 500);
    }
  }
}

</script>


// WEBPACK FOOTER //
// organization.vue?321a88c4